import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["triggerRef"];
import React from 'react';
import styled from '@emotion/styled';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import DropdownMenu, { DropdownItemRadio } from '@atlaskit/dropdown-menu';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { ButtonItem } from '@atlaskit/menu';
import { ThemeIcon } from '../icons/theme';
import DarkModeThumbnail from './thumbnails/dark-mode.svg';
import LightModeThumbnail from './thumbnails/light-mode.svg';
import MatchBrowserThumbnail from './thumbnails/match-browser.svg';
export var ThemeSwitcher = function ThemeSwitcher(_ref) {
  var testId = _ref.testId,
    onThemeChange = _ref.onThemeChange,
    currentTheme = _ref.currentTheme;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    testId: testId,
    placement: "auto-start",
    trigger: function trigger(_ref2) {
      var triggerRef = _ref2.triggerRef,
        props = _objectWithoutProperties(_ref2, _excluded);
      return /*#__PURE__*/React.createElement(ButtonItem, _extends({
        ref: triggerRef,
        onClick: function onClick(event) {
          return event.stopPropagation();
        },
        iconBefore: /*#__PURE__*/React.createElement(ThemeIcon, {
          label: ""
        }),
        iconAfter: /*#__PURE__*/React.createElement(ChevronRightIcon, {
          label: ""
        })
      }, props), /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "identity.account-menu.theme-switcher.theme-button",
        defaultMessage: "Theme",
        description: "Label for button in the account menu to switch to a different theme"
      }));
    }
  }, themeOptions.map(function (_ref3) {
    var label = _ref3.label,
      value = _ref3.value,
      thumbnail = _ref3.thumbnail;
    return /*#__PURE__*/React.createElement(DropdownItemRadio, {
      testId: "".concat(testId, "--radio-").concat(value),
      id: value,
      key: value,
      onClick: function onClick() {
        return onThemeChange(value);
      },
      isSelected: currentTheme === value
    }, /*#__PURE__*/React.createElement(RadioLabelContainer, null, /*#__PURE__*/React.createElement("img", {
      src: thumbnail,
      width: 64,
      height: 48,
      alt: ""
    }), label));
  }));
};
var RadioLabelContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-150, 12px)"
});
var messages = defineMessages({
  light: {
    id: 'identity.account-menu.theme-switcher.light.option',
    defaultMessage: 'Light',
    description: 'Label for the theme switcher light option'
  },
  dark: {
    id: 'identity.account-menu.theme-switcher.dark.option',
    defaultMessage: 'Dark',
    description: 'Label for the theme switcher dark option'
  },
  matchBrowser: {
    id: 'identity.account-menu.theme-switcher.match-browser.option',
    defaultMessage: 'Match browser',
    description: 'Label for the theme switcher match browser option'
  }
});
var themeOptions = [{
  label: /*#__PURE__*/React.createElement(FormattedMessage, messages.light),
  value: 'light',
  thumbnail: LightModeThumbnail
}, {
  label: /*#__PURE__*/React.createElement(FormattedMessage, messages.dark),
  value: 'dark',
  thumbnail: DarkModeThumbnail
}, {
  label: /*#__PURE__*/React.createElement(FormattedMessage, messages.matchBrowser),
  value: 'auto',
  thumbnail: MatchBrowserThumbnail
}];